import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import moment from "moment";
import withStyles from '@material-ui/core/styles/withStyles';
import { getFormattedDate } from 'Utils';
import { instance } from "../../../../../../../Actions/AxiosInstance";
import TextField from "@material-ui/core/TextField";



const styles = () => ({
  root: {
    marginBottom: '8px',
  },
  textArea: {
    marginBottom: '20px',
  },
  textMessage: {
    marginTop: '10px',
    marginBottom: '10px',
    fontSize: '14px',
    color: '#010709',
    opacity: '0.7',
    '& p': {
      margin: 0,
      fontSize: '14px',
      color: '#010709',
    },
  },
  actionCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  duedateText: {
    margin: 0,
    fontSize: 12,
    color: '#010709',
    opacity: '0.7',
  },
  actionSection: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

});


class Message extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activitytypeid: 1,
      message: null,
      doneButton: null,
      comment: null,
    };
  }

  componentDidMount = () => {
    if (this.props.activityObject) {
      this.setState({
        message: this.props.activityObject.message,
        doneButton: this.props.activityObject.isdone,
      });
    }
  };

  static getDerivedStateFromProps(props, state) {
    if (props.activityObject.isdone !== state.doneButton) {
      const object = { ...state, doneButton: props.activityObject.isdone };
      return object;
    }
    return null;
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.activityObject.isdone !== prevProps.activityObject.isdone) {
  //     this.setState({
  //       doneButton: this.props.activityObject.isdone,
  //     });
  //   }
  // }

  setFeedback(value) {
    this.setState({
      comment: value,
    });
  }


  onDoneConfirmation(item) {
    const { checklist } = this.props;
    if( checklist && checklist.isseqcompletion == false ){
        this.props.enqueueSnackbar("Are you sure this is done?", {
          variant: "warning",

          action: [
            <Button
              color="inherit"
              size="small"
              onClick={() => this.onDone(item)}
            >
              Done
            </Button>,

            <Button
              color="inherit"
              size="small"
              onClick={() => {
                //this.setState({ isEdit: false });
                this.props.closeSnackbar();
              }}
            >
              Cancel
            </Button>,
          ],
        });
    }else if( checklist && checklist.isseqcompletion == true ){
      this.props.enqueueSnackbar("Please mark as done only when the activity is complete. Sequential activities cannot be undone, are you sure this is done?", {
        variant: "warning",

        action: [
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              this.onDone(item);
              this.props.closeSnackbar();}}
            
          >
            Done
          </Button>,

          <Button
            color="inherit"
            size="small"
            onClick={() => {
              //this.setState({ isEdit: false });
              this.props.closeSnackbar();
              this.props.reloadChecklistOnDone(this.props.checklist);
            }}
          >
            Cancel
          </Button>,
        ],
      });
    }
  }

  async onDone(done) {
    try {
      await instance.put(`checklist/updateactivity`, {
        isdone: done,
        empchecklistid: this.props.postData.empchecklistid,
        empchecklistactivityid: this.props.activityObject.empchecklistactivityid,
        checklistactivityid: this.props.activityObject.checklistactivityid,
        isshared: this.props.isShared,
        comment: this.state.comment
      });
      this.props.enqueueSnackbar("Successfully", { variant: "success" });
      this.props.reloadChecklistOnDone(this.props.checklist);
    } catch (error) {
      this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
    }
  }


  render() {
    const { message, duedays, fullname, doneon, isallowedone, comment } = this.props.activityObject;
    const { classes, checklist } = this.props;
    const effectiveDate = moment(checklist.effectivefrom);
    effectiveDate.add(duedays, 'days');
    const currentDate = moment();
    return (
      <Grid container className={classes.root} direction='row'>
        <Grid item xs={12} className={classes.textArea}>
          <div dangerouslySetInnerHTML={{ __html: message }} className={classes.textMessage}>
          </div>
        </Grid>
        <Grid item md={12} sm={12}>
          {this.state.doneButton ? (
            <div>
            {comment && (
              <p className="small-dark-secondary">
                <strong>Comment:</strong> {comment}
              </p>
            )}
          </div>
          ) : (
            <div className="req-center-textarea margin-bottom-16">
              <p className="input-label">Comment</p>

              <TextField
                onChange={(e) => this.setFeedback(e.target.value)}
                value={this.state.comment}
                id="outlined-bare"
                type="text"
                variant="outlined"
                multiline
                style={{ width: "100%" }}
                minRows={4}
                maxRows={4}
                inputProps={{ maxLength: 500 }}
              />
            </div>
          )}
        </Grid>
        <Grid xs={12} className={classes.actionCenter}>
          <Grid xs={8}>
            {this.state.doneButton
            ? <p className={classes.duedateText}> {fullname} completed this on {getFormattedDate(doneon)}</p>
            : checklist.effectivefrom ? <p className={classes.duedateText}>Due {currentDate.to(effectiveDate)} </p> : <p className={classes.duedateText}>No Due Date</p>}
          </Grid>
          <Grid xs={4} className={classes.actionSection}>
            {this.state.doneButton == false ? <Button color="primary" className="btn btn-primary-sm-blue" variant="contained" onClick={() => this.onDoneConfirmation(true)} disabled={!isallowedone}> Done </Button>
              : checklist.isseqcompletion == false ? <Button color="primary" className="btn" classes={{ root: "bgcolor-dodgerRed" }} variant="contained" onClick={() => this.onDoneConfirmation(false)} disabled={!checklist.isactive} > Undo </Button> : ""}
          </Grid >
       </Grid >
       {checklist.isseqcompletion == true && isallowedone== false && this.state.doneButton == false &&( 
        <Grid xs={12} style={{marginTop:8}}>
          <p className="input-label">
            Note: You can't complete this sequential activity until the preceding activity is complete.
          </p>
        </Grid>
      )}
      </Grid >
    );
  }
}

export default withSnackbar(withStyles(styles)(Message));
